fabric.Object.prototype.noScaleCache = false;

var locket,
  object,
  charm = 1,
  charms = 7,
  newZoomLevel,
  zoom,
  loader = jQuery('#customLoader'),
  cSize = '765.188',
  topBase = cSize * 1.25,
  baseImg = jQuery('.base.active').attr('src'),
  canvas = this.__canvas = new fabric.Canvas('customArea', {
    width: cSize,
    height: cSize,
    backgroundColor: '#FFFFFF',
    preserveObjectStacking: true,
    selection: true,
    allowTouchScrolling: false,
    controlsAboveOverlay: true,
    isTouchSupported: false
  });

fabric.Object.prototype.borderColor = '#cccccc';
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = '#7c8f7f';
fabric.Object.prototype.cornerStyle = 'circle';

canvasBlock();

fabric.Image.fromURL(baseImg, function (img) {
  var oImg = img.set({
    left: 0,
    top: 0,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  }).scaleToWidth(cSize);

  canvas.setBackgroundImage(oImg);
  canvas.requestRenderAll();
});

jQuery(window).resize(function () {
  canvasBlock();
});

loader.hide();

function getMaxCharms() {
  return parseInt(jQuery('#variantCharmLimit').val(), 10) || 6;
}

function getSelectedCharmCount() {
  return jQuery('.locket.active').length;
}

function updateCharmCounter() {
  jQuery('.charmNum').text(getSelectedCharmCount());
}

function extractCharmLimit(text) {
  var match = text.match(/\d+/);
  return match ? parseInt(match[0], 10) : 6;
}

function resetCharms() {
  charm = 1;
  jQuery('.charmNum').text(0);
  jQuery('.locket').removeClass('active disabled');
  jQuery('#showAgreement').removeClass('active');
  jQuery('#checkAgree').prop('checked', false);
  jQuery('.js-ajax-submitM').attr('disabled', 'disabled');
}

function updateCharmLimitFromVariant(value) {
  var maxCharms = extractCharmLimit(value);

  jQuery('#variantCharmLimit').val(maxCharms);
  jQuery('#maxCharms').text(maxCharms);

  charms = maxCharms + 1;

  resetCharms();
}

jQuery(document).on('click', '.locket', function () {
  locket = jQuery(this);

  var maxCharms = getMaxCharms();
  var selectedCount = getSelectedCharmCount();

  if (locket.hasClass('disabled')) return;

  if (locket.hasClass('active')) {
    locket.removeClass('active');
  } else {
    if (selectedCount >= maxCharms) return;
    locket.addClass('active');
  }

  updateCharmCounter();
  activeAction();
});

function activeAction() {
  var maxCharms = getMaxCharms();
  var selectedCount = getSelectedCharmCount();

  if (selectedCount >= maxCharms) {
    showAgreement();

    jQuery('.locket').each(function () {
      if (!jQuery(this).hasClass('active')) {
        jQuery(this).addClass('disabled');
      }
    });
  } else {
    jQuery('#showAgreement').removeClass('active');
    jQuery('#checkAgree').prop('checked', false);
    jQuery('.js-ajax-submitM').attr('disabled', 'disabled');

    jQuery('.locket').each(function () {
      jQuery(this).removeClass('disabled');
    });
  }
}

function showAgreement() {
  jQuery('#showAgreement').addClass('active');
}

jQuery(document).on('change', 'input[name="agreement"]', function () {
  if (jQuery(this).is(':checked')) {
    jQuery('.js-ajax-submitM').removeAttr('disabled');
  } else {
    jQuery('.js-ajax-submitM').attr('disabled', 'disabled');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var variantRadios = document.querySelectorAll('input[name^="options["]');
  var productDataScript = document.querySelector('script[id^="ProductJson-"]');
  var productData = null;

  if (productDataScript) {
    try {
      productData = JSON.parse(productDataScript.textContent);
    } catch (error) {
      console.error('Failed to parse product JSON:', error);
    }
  }

  function updateSelectedVariant() {
    if (!productData) return;

    var selectedOptions = [];

    document.querySelectorAll('input[name^="options["]:checked').forEach(function (radio) {
      selectedOptions.push(radio.value);
    });

    var matchedVariant = productData.variants.find(function (variant) {
      return variant.options.every(function (optionValue, index) {
        return optionValue === selectedOptions[index];
      });
    });

    if (matchedVariant) {
      document.querySelectorAll('.formVariantId, #selected-variant-id').forEach(function (input) {
        input.value = matchedVariant.id;
      });

      fetch('/variants/' + matchedVariant.id + '.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (variant) {
          var priceElement = document.querySelector('[data-product-price]');
          if (priceElement) {
            var formattedPrice = (variant.price / 100).toFixed(0);
            priceElement.textContent = '$' + formattedPrice + ' ';
          }
        })
        .catch(function (error) {
          console.error('Error fetching variant price:', error);
        });
    }
  }

  variantRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.name === 'options[Size]') {
        updateCharmLimitFromVariant(this.value);
      }

      updateSelectedVariant();
    });
  });

  var checkedSize = document.querySelector('input[name="options[Size]"]:checked');

  if (checkedSize) {
    updateCharmLimitFromVariant(checkedSize.value);
  }

  updateSelectedVariant();
});

function canvasBlock() {
  jQuery('.product__section-images').removeAttr('style');
  zoom = jQuery('.product__section-images').innerWidth();
  newZoomLevel = zoom / cSize;
  setZoomMask(newZoomLevel);
}

function setZoomMask(newZoomLevel) {
  var zoomLevel = newZoomLevel;

  canvas.setZoom(zoomLevel);
  canvas.setDimensions({
    width: cSize * zoomLevel,
    height: cSize * zoomLevel
  });

  canvas.renderAll();
  jQuery('.steps__').css('max-height', cSize - 60);
}

canvas.on('object:added', function (e) {
  object = e.target;

  object.setControlsVisibility({
    bl: false,
    br: false,
    mb: false,
    ml: false,
    mr: false,
    mt: false,
    mtr: false,
    tl: false,
    tr: false
  });
});

canvas.on('object:modified', function (e) {
  object = e.target;
});

function deleteObject(eventData, transform) {
  var target = transform.target;
  var canvas = target.canvas;

  canvas.remove(target);
  canvas.requestRenderAll();
}

function renderIcon(icon) {
  return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    var size = this.cornerSize;

    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

var otherProducts = '', storke;

jQuery(document).on('click', '.js-ajax-submitM', function (e) {
  e.preventDefault();

  loader.show();

  var maxCharms = getMaxCharms();
  var selectedCount = getSelectedCharmCount();

  if (selectedCount !== maxCharms) {
    loader.hide();
    return;
  }

  var i = 0;

  jQuery('.locket.active').each(function () {
    locket = jQuery(this);
    otherProducts = locket.parent().parent().attr('data-alpha');

    i++;

    jQuery('.myProperty').append(
      '<input name="properties[Charm ' + i + ']" type="hidden" value="' + otherProducts + '">'
    );
  });

  charm = 1;
  activeAction();

  loader.hide();

  jQuery('.js-ajax-submit').trigger('click');

  setTimeout(function () {
    jQuery('.myOrders').html('');
    jQuery('.myProperty').html('');
  }, 500);
});

const svgRotateIcon = encodeURIComponent(`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d)">
    <circle cx="9" cy="9" r="5" fill="white"/>
    <circle cx="9" cy="9" r="4.75" stroke="black" stroke-opacity="0.3" stroke-width="0.5"/>
  </g>
  <path d="M10.8047 11.1242L9.49934 11.1242L9.49934 9.81885" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.94856 6.72607L8.25391 6.72607L8.25391 8.03142" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.69517 6.92267C10.007 7.03301 10.2858 7.22054 10.5055 7.46776C10.7252 7.71497 10.8787 8.01382 10.9517 8.33642C11.0247 8.65902 11.0148 8.99485 10.9229 9.31258C10.831 9.63031 10.6601 9.91958 10.4262 10.1534L9.49701 11.0421M8.25792 6.72607L7.30937 7.73554C7.07543 7.96936 6.90454 8.25863 6.81264 8.57636C6.72073 8.89408 6.71081 9.22992 6.78381 9.55251C6.8568 9.87511 7.01032 10.174 7.23005 10.4212C7.44978 10.6684 7.72855 10.8559 8.04036 10.9663"
    stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  <defs>
    <filter id="filter0_d" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.137674 0 0 0 0 0.190937 0 0 0 0 0.270833 0 0 0 0.15 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
  </defs>
</svg>
`);

const rotateIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`;
const brIcon = document.createElement('img');

const svgRemoveIcon = encodeURIComponent(`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d)">
    <circle cx="9" cy="9" r="5" fill="white"/>
    <circle cx="9" cy="9" r="4.75" stroke="black" stroke-opacity="0.3" stroke-width="0.5"/>
  </g>
  <path fill="#000" d="M6.9,11.1c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1L9,9.4l1.6,1.6c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.3,0-0.4L9.4,9l1.6-1.6c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0L9,8.6L7.4,6.9c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.3,0,0.4L8.6,9l-1.6,1.6C6.8,10.8,6.8,10.9,6.9,11.1z"/>
  <defs>
    <filter id="filter0_d" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.137674 0 0 0 0 0.190937 0 0 0 0 0.270833 0 0 0 0.15 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
  </defs>
</svg>
`);

const removeIcon = `data:image/svg+xml;utf8,${svgRemoveIcon}`;
const tlIcon = document.createElement('img');

brIcon.src = rotateIcon;
tlIcon.src = removeIcon;

fabric.Object.prototype.controls.br = new fabric.Control({
  x: 0.5,
  y: 0.5,
  offsetX: 0,
  offsetY: 0,
  cursorStyle: 'crosshair',
  actionHandler: fabric.controlsUtils.rotationWithSnapping,
  actionName: 'rotate',
  render: renderIcon(brIcon),
  cornerSize: 38,
  withConnection: true
});

fabric.Object.prototype.controls.tl = new fabric.Control({
  x: -0.5,
  y: -0.5,
  offsetX: 0,
  offsetY: 0,
  cursorStyle: 'pointer',
  mouseUpHandler: deleteObject,
  render: renderIcon(tlIcon),
  cornerSize: 38,
  withConnection: true
});